/* assets/src/viewer/interaction/hotspots.js
 * Hotspot cliccabili sul modello via raycasting (skill threejs-interaction).
 * Click sul telo/lamelle -> apri/chiudi copertura; click sulla struttura -> focus finiture.
 * Distingue click da drag/orbita (soglia movimento/tempo).
 */
import { Raycaster, Vector2 } from 'three';

export class Hotspots {
  constructor(viewer) {
    this.viewer = viewer;
    this.ray = new Raycaster();
    this.ndc = new Vector2();
    this._down = null;
    const dom = viewer.renderer.domElement;
    dom.addEventListener('pointerdown', (e) => { this._down = { x: e.clientX, y: e.clientY, t: performance.now() }; }, { passive: true });
    dom.addEventListener('pointerup', (e) => this._onUp(e), { passive: true });
  }

  _onUp(e) {
    if (!this._down) return;
    const moved = Math.hypot(e.clientX - this._down.x, e.clientY - this._down.y);
    const dt = performance.now() - this._down.t;
    this._down = null;
    if (moved > 6 || dt > 500) return; // era un'orbita/drag

    const model = this.viewer.controller && this.viewer.controller.model;
    if (!model) return;
    const rect = this.viewer.renderer.domElement.getBoundingClientRect();
    this.ndc.set(((e.clientX - rect.left) / rect.width) * 2 - 1, -((e.clientY - rect.top) / rect.height) * 2 + 1);
    this.ray.setFromCamera(this.ndc, this.viewer.camera);
    const hits = this.ray.intersectObject(model.group, true);
    if (!hits.length) return;

    const obj = hits[0].object;
    const role = obj.material && obj.material.userData ? obj.material.userData.asgRole : null;
    if (role === 'louver' || role === 'fabric' || role === 'glass') {
      if (typeof window.ASG_ToggleRoof === 'function') window.ASG_ToggleRoof();
    } else if (window.ASG_Viewer && typeof window.ASG_Viewer.focusCategory === 'function') {
      window.ASG_Viewer.focusCategory('finishes');
    }
    this.viewer.requestRender();
  }
}
